import { FC } from 'react';
import { Marker } from 'react-leaflet';
import { getIcon } from '../../util/maps';
import { LocationPinFilled } from '../icons';
import { LocationPinProps } from './page-map.types';

export const LocationPin: FC<LocationPinProps> = ({ children, position }) => {
  return (
    <Marker
      icon={getIcon(<LocationPinFilled />)}
      position={position}
    >
      {children}
    </Marker>
  );
};
